import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import moment from 'moment';

import { EllipsisTooltip } from '@/components';
import { DATE_TIME_FORMAT } from '@/config';
import { getPlainTextFromDescription } from '@/pages/Notes/NotesDataGridWrapper';
import { formatPersonName } from '@/utils';

const type = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    const typeName = params.row?.type?.name || '-';
    const isCaution = params.row?.type?.isCaution;
    return (
      <Box
        sx={{
          width: params.colDef.computedWidth - 10,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <EllipsisTooltip style={{ fontSize: '0.875rem' }}>
          {typeName}
          &nbsp;
          {isCaution && <WarningAmberIcon color="error" />}
        </EllipsisTooltip>
      </Box>
    );
  },
  valueGetter: (_, row) => row.type?.name,
});

const comment = (): Partial<GridColDef> => ({
  renderCell: (params) => (
    <Box
      sx={{
        width: params.colDef.computedWidth - 10,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <EllipsisTooltip style={{ fontSize: '0.875rem' }}>
        {getPlainTextFromDescription(params?.row?.comment) || ''}
      </EllipsisTooltip>
    </Box>
  ),
});

const createdAt = (): Partial<GridColDef> => ({
  renderCell: (params) =>
    moment(params.row?.createdAt).format(DATE_TIME_FORMAT) || '-',
});

const createdBy = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    if (params.row?.createdBy?.firstName) {
      return formatPersonName(params.row?.createdBy);
    }
    return params.row?.createdBy?.email || '-';
  },
  valueGetter: (_, row) => formatPersonName(row?.createdBy),
});

const actions = (handleDelete?: (id: string) => void): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => (
    <Button
      variant="text"
      color="error"
      onClick={(e) => {
        e.stopPropagation();
        handleDelete?.(params.row._id);
      }}
    >
      Delete
    </Button>
  ),
});

export const addressNoteCols = (handleDelete?: (id: string) => void) => {
  return {
    type,
    comment,
    createdAt,
    createdBy,
    actions: () => actions(handleDelete),
  };
};
